import './components/sliders';
import './components/burger';
import './components/getDinamicHeight';
import './components/filters';
import './components/tabs';
// import './components/accordions';
import './components/select';
import './components/inputMask';
import './components/hiddenCards';
import './components/quiz';




